var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.histories.length
    ? _c(
        "Collapse",
        {
          staticClass: "tenant-submission-comment-history",
          attrs: { expand: false, withBorder: false },
        },
        [
          _c(
            "div",
            {
              staticClass: "comment-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("tenantProjects.sendHistory")) + "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "table",
            {
              staticClass: "history-table",
              attrs: { slot: "content" },
              slot: "content",
            },
            [
              _c("thead", [
                _c(
                  "tr",
                  _vm._l(_vm.historyHeaders, function (header, index) {
                    return _c("th", { key: index, class: header.class }, [
                      _vm._v(
                        "\n          " + _vm._s(header.title) + "\n        "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.histories, function (history, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(history.createdBy.displayName))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(history.emailReceivers.to.replace(/;/g, "; "))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(history.emailReceivers.cc.replace(/;/g, "; "))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(history.emailReceivers.bcc.replace(/;/g, "; "))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "white-space": "nowrap" } }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("customStatusLabel")(history.actionType)
                            )
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.dateUtil.formatDate(history.createdAt, true))
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }